<template>
  <v-app class="app" :class="isHeaderFooterVisible ? '' : 'ortala'">
    <Header v-if="isHeaderFooterVisible" />
    <LoggedInMobile />
    <article v-if="!getIsErrorPageOpen" itemscope itemtype="http://schema.org/Article">
      <main :class="{ 'main': !isHomePage && !isLoginPage && !isRegisterPage && !isRamsPage }">
        <div itemprop="articleBody">
          <NuxtPage />
          <WidgetManager />
        </div>
      </main>
    </article>
    <Error v-else />
    <cookiesBanner data-nosnippet />
    <slot />
    <Footer v-if="isFooterVisible && route.path !== '/rams'" />
    <globalLoading />
  </v-app>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch, watchEffect, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import globalLoading from "./components/globalLoading.vue";
import Header from "./components/layout/header.vue";
import Footer from "./components/layout/footer.vue";

import cookiesBanner from "./components/cookiesBanner.vue";
import LoggedInMobile from "./components/header/loggedInMobile.vue";
import Error from "./error.vue";
import { useMyCookieStore } from "./stores/cookie";
import { useMyIlanlarStore } from "./stores/ilanlar";
import { useMyNotificationsStore } from "./stores/notifications";
import { useMyUserStore } from "./stores/user";
import { useErrorStore } from "./stores/error";
import { mapState } from "pinia";
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiMessageOutline } from '@mdi/js';
import whiteLogo from '~/assets/images/logo-icon.svg';
import WidgetManager from './components/widgets/widgetManager.vue';
export default defineComponent({
  components: {
    globalLoading,
    Header,
    Footer,
    Error,
    cookiesBanner,
    LoggedInMobile,
    SvgIcon,
    WidgetManager
  },
  setup() {
    const route = useRoute();
    const isHeaderFooterVisible = ref(false);
    const isHomePage = computed(() => route.path === '/');
    const isLoginPage = computed(() => route.path === '/giris-yap');
    const isRegisterPage = computed(() => route.path === '/uye-ol');
    const isRamsPage = computed(() => route.path === '/rams' );
    const isFooterVisible = ref(false);
    const config = useRuntimeConfig();

    if (process.client) {
      const hostname = window.location.hostname;
      if (hostname.includes('dev.') || hostname.includes('pre.')) {
        useHead({
          meta: [
            { name: 'robots', content: 'noindex, nofollow' }
          ]
        });
      }
    }
    onMounted(async () => {
      await nextTick();
      setTimeout(() => {
        isFooterVisible.value = true;
      }, 100);
      const { updatedAppVueCookie } = useMyCookieStore();
      updatedAppVueCookie();
      isHeaderFooterVisible.value = !(
        route.path.includes("giris-yap") ||
        route.path.includes("uye-ol") ||
        route.path.includes("sifremi-unuttum") ||
        route.path === "/rams"
      );
    });
    watch(
        () => route.path,
        (newName) => {
          useErrorStore().setIsErrorPageOpen(false);
          const func = async () => {
            const { updatedAppVueCookie } = await useMyCookieStore();
            updatedAppVueCookie();
          }
          func()
        },
        { immediate: true } 
      );
    
    watchEffect(() => {
      if (
        route.path.includes("giris-yap") ||
        route.path.includes("uye-ol") ||
        route.path.includes("sifremi-unuttum") ||
        route.path === "/rams"
      ) {
        isHeaderFooterVisible.value = false;
      } else {
        isHeaderFooterVisible.value = true;
      }
      watch(
        () => route.path,
        (newName) => {
          if (!(newName == '/')) {
            useHead({
              title: `Divissa | ${capitalize(String(newName.replace(/^\//, '')))}`,
            });
          } 
          useErrorStore().setIsErrorPageOpen(false);
          const func = async () => {
            const { updatedAppVueCookie } = await useMyCookieStore();
            updatedAppVueCookie();
          }
          func()
        },
        { immediate: true } // Başlangıçta çalıştırmak için
      );
      function capitalize(str: string) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      }
    });
    const useStore = useMyIlanlarStore();
    useStore.clearFilters();


    return {
      isHeaderFooterVisible,
      isFooterVisible,
      isHomePage,
      isLoginPage,
      isRegisterPage,
      isRamsPage,
      config,
      SvgIcon,
      WidgetManager,
      mdiMessageOutline,
      whiteLogo
    };
  },

  data() {
    return {
      token: null as string | null | any,
      cookiesSettingsDialog: false as boolean,
      router: useRouter(),
      route: useRoute(),
    };
  },

  beforeMount() {
    this.checkStoreToken();
  },

  mounted() {
    if (this.token) {
      this.fetchBildirimler();
      this.fetchUserProfile();
    }
  },
  
  computed: {
    ...mapState(useErrorStore, [
      "getIsErrorPageOpen",
    ]),
  },
  
  methods: {
    async fetchUserProfile() {
      const useStore = useMyUserStore();
      await useStore.FetchMe();
    },
    checkStoreToken() {
      const useStore = useMyUserStore();
      if (useStore.token) this.token = useStore.token;
      else if (localStorage.getItem("token"))
        this.token = localStorage.getItem("token");
    },

 

    async fetchBildirimler() {
      const useStore = useMyNotificationsStore();
      useStore.setSignalRConnection(this.token);
    },
  },
});
</script>

<style lang="less">
.main{
  margin-top: 100px;
}
.v-application.ortala {
  .v-application__wrap {
    justify-content: center;
  }
}

</style>